import { render, staticRenderFns } from "./recordSummary.vue?vue&type=template&id=c3d23012&"
import script from "./recordSummary.vue?vue&type=script&lang=js&"
export * from "./recordSummary.vue?vue&type=script&lang=js&"
import style0 from "./recordSummary.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports